import { render, staticRenderFns } from "./ImagePlug.vue?vue&type=template&id=b2b60f9c&scoped=true"
import script from "./ImagePlug.vue?vue&type=script&lang=js"
export * from "./ImagePlug.vue?vue&type=script&lang=js"
import style0 from "./ImagePlug.vue?vue&type=style&index=0&id=b2b60f9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b60f9c",
  null
  
)

export default component.exports